import Vue from 'vue'
import Vuex from 'vuex'
import cookie from 'vue-cookies'
Vue.use(Vuex);
export default new Vuex.Store({
  state: {

    STREAMER:{
      FIRST_NAME:"Okänd",
      LAST_NAME:"",
      STREAMELEMENTS:false,
      STREAMLABS:false,
      HIHAT:false,
      STREAMER_NAME:"",
      PHONE_NUMBER:"",
      BANKACCOUNT:"",
      PAYMENT_TYPE:"",
      PERSONAL_NUMBER:"",
      HAS_NIGHTBOT:false,
      SID:0,
      USER_NAME:"",
      IS_ADMIN:false,
      IN_BCF:false,
      DISCORD_CHANNEL:""
    },
    HICARDS:{
      HICARDS_ID: "",
      CARDS: 0,
      SID: 0,
      STATUS: 0,
      ACTIVE: 0,
      BOX_PREF: "",
      FLEX_REQUIREMENT: 0,
      FLEX_COOLDOWN: 0,

    },
    STYLE:{

    },
    MEDIA:{
      USER_IMAGE:"/api/images/users/default.png",
      HEADER:null
    },
    APP:{
      NEW_CARDS:0,
      NEW_TRADES:0,
      SETUP_LOADED:false,
      HICARDS_LOADED:false,
      DRAWER_MENU:false,
      SHOW_NEW_PASSWORD:false,
      LOGIN_CALLBACK:null,
      SHOW_LOGIN:false,
      SHOW_LOGOUT:false,
      SHOW_CREATE:false,
      CREATE_PAGE:1,
      INVENTORY:{
        COLLECTION_CARDS:[],
        COLLECTION_DISPLAY:false,
        COLLECTION_SELECTED:null,
        ACTION_SELECTED:null
      },
      ACTION_CARDS:[[],[],[],[]],
      SNACKBAR:{
        SHOW:false,
        MESSAGE:""
      }
    }
  },
  actions:{
    async update_user_image({state,commit}){
      var image = new Image();

      image.onload = function() {
        commit("update_user_image",image.src);
      };
      image.onerror = function() {

        commit("update_user_image","/api/avatar/"+state.STREAMER.USER_NAME.toLowerCase());
      };

      image.src = "/api/images/users/"+state.STREAMER.SID+".png";

    },
    get_style_data({state,commit,dispatch}){
      let http = new XMLHttpRequest();
      http.withCredentials = true;

      let url = '/api/getStyles?';
      let params = '';
      http.open('POST', url, true);

      http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

      http.onreadystatechange = function() {//Call a function when the state changes.



        if(http.readyState === 4 && http.status === 200){

          let data = JSON.parse(http.response);

          if(!data["error"]){
            commit("set_style_data",data);
          }
          else if(data["error"]){
            if(data["error"]==="no record"){
              let data={
                PATH:state.STREAMER.USER_NAME+"_"+(Math.random()*100).toFixed(0),
                USER_NAME:state.STREAMER.USER_NAME,
                MIN_DONATION:20,
                TITLE:"Donera",
                SUGGESTION_ONE:'[29,59,99]',
                SUGGESTION_TWO:0,
                SUGGESTION_THREE:1,
                START_COLOR:"#47b78f",
                END_COLOR:"#5a9580",
                DESC:"Tack för din support!"
              }
              commit("set_style_data",data);
              commit("save_style");


            }
          }
          dispatch("get_bcf_status");


        }

      };
      http.send(params);


    },


    get_settings_data({state, commit, dispatch }){
      let http = new XMLHttpRequest();
      http.withCredentials = true;

      let url = '/api/getSettings?';
      let params = '';
      http.open('POST', url, true);
      http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      http.onreadystatechange = function() {//Call a function when the state changes.


        if(http.readyState === 4 && http.status === 200){
          commit("set_settings_data",JSON.parse(http.responseText));
          dispatch("update_user_image",{state});
          dispatch("get_style_data");
          dispatch("get_hicards_data");




        }

      };
      http.send(params);

    },
    get_bcf_status({state }){
      let http = new XMLHttpRequest();
      http.withCredentials = true;

      let url = '/api/in_bcf?path='+state.STYLE.PATH;
      http.open('GET', url, true);
      http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      http.onreadystatechange = function() {//Call a function when the state changes.


        if(http.readyState === 4 && http.status === 200){
          let resp=JSON.parse(http.responseText);
          if(resp["in_bcf"]){
            state.STREAMER.IN_BCF=true;
          }else{
            state.STREAMER.IN_BCF=false;

          }




        }

      };
      http.send();

    },


    get_hicards_data({commit}){
      let http = new XMLHttpRequest();
      http.withCredentials = true;

      let url = '/api/hicards_settings';
      let params = '';
      http.open('GET', url, true);

      http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

      http.onreadystatechange = function() {//Call a function when the state changes.



        if(http.readyState === 4 && http.status === 200){

          let data = JSON.parse(http.response);
          if(!data["error"]){
            commit("set_hicards_data",data);


          }


        }

      };
      http.send(params);
    },
    get_num_trades({commit}){
      let http = new XMLHttpRequest();
      http.withCredentials = true;

      let url = '/api/get_my_trades';
      http.open('GET', url, true);
      http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      http.onreadystatechange = function() {//Call a function when the state changes.
        if(http.readyState === 4 && http.status === 200){
          let resp=JSON.parse(http.response);

          commit("set_num_trades",resp.length);

        }};
      http.send();
    },
      reset_num_cards({state,dispatch}){
        let prev_num_cards=parseInt(cookie.get("num_hicards"));

        cookie.set("num_hicards", prev_num_cards+state.APP.NEW_CARDS);
        dispatch("get_num_cards");
      },

      get_num_cards({state, commit }){
      let id = state.STREAMER.SID;

      let http = new XMLHttpRequest();
      http.withCredentials = true;
      let url = '/api/get_collector_stats?sid='+id;

      http.open("GET", url, true);
      http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

      http.onreadystatechange = function () {

        if (http.readyState === 4) {
          if(http.status > 400){

            console.log("error");

          }
          else {
            let data=JSON.parse(http.response);
            let total=0;


            for(let i=0;i<data.all.length;i++){
              if(data.all[i].RANK_VALUE===0){
                total+=data.all[i].COUNTED
              }
              else if(data.all[i].RANK_VALUE===1){
                total+=data.all[i].COUNTED
              }
              else if(data.all[i].RANK_VALUE===2){
                total+=data.all[i].COUNTED
              }
              else if(data.all[i].RANK_VALUE===3){
                total+=data.all[i].COUNTED
              }
            }
            if(!cookie.isKey("num_hicards")){
              cookie.set("num_hicards",total);
            }
            else{
              commit("set_num_cards",total);
            }


          }

        }
      };
      http.send();
    }


  },

  getters:{
    loggedIn(state){
      return (state.STREAMER.SID>0 && state.STREAMER.SID!==null && state.STREAMER.SID!==undefined)
    }
  },
  mutations:{
    save_streamer(state){
      if(state.APP.SETUP_LOADED && state.APP.HICARDS_LOADED){
          let http = new XMLHttpRequest();
          http.withCredentials = true;
          let hicards_active=state.HICARDS.ACTIVE ? 1 : 0;
          let url = '/api/settings?';
          let params = 'firstName='+state.STREAMER.FIRST_NAME+'&lastName='+state.STREAMER.LAST_NAME+'&streamerName='+"twitch"+"NO_INFO"+'&phoneNumber='+state.STREAMER.PHONE_NUMBER+'&bankAccount='+state.STREAMER.BANKACCOUNT+'&paymentType='+state.STREAMER.PAYMENT_TYPE+'&personalNumber='+state.STREAMER.PERSONAL_NUMBER+"&hicardStatus="+hicards_active+"&discordChannel="+state.STREAMER.DISCORD_CHANNEL;
          http.open('POST', url, true);

          http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
          http.onreadystatechange = function() {//Call a function when the state changes.



            if(http.readyState === 4 && http.status === 401) {

              state.APP.SNACKBAR.SHOW=true;
              state.APP.SNACKBAR.MESSAGE="Ett fel inträffade";

            }

          };

          http.send(params);
      }

    },
    save_style(state){
      let http = new XMLHttpRequest();
      http.withCredentials = true;

      let url = '/api/styles?';
      let header="nvm";

      let suggestions=state.STYLE.SUGGESTION_ONE;
      let dark_mode= state.STYLE.SUGGESTION_TWO;
      let show_leaderboard= state.STYLE.SUGGESTION_THREE;
      state.STYLE.PATH=state.STYLE.PATH.replace(/\W/g, '')
      state.STYLE.PATH=state.STYLE.PATH.replace(' ', '');

      let params ='PATH='+state.STYLE.PATH+'&MIN_DONATION='+state.STYLE.MIN_DONATION+'&TITLE='+state.STYLE.TITLE+'&SUGGESTION_ONE='+suggestions+'&SUGGESTION_TWO='+dark_mode+'&SUGGESTION_THREE='+show_leaderboard+'&START_COLOR='+state.STYLE.START_COLOR+'&END_COLOR='+state.STYLE.END_COLOR+'&DESC='+state.STYLE.DESC+'&IMAGE='+header;

      //PATH,MIN_DONATION,TITLE,SUGGESTION_ONE,SUGGESTION_TWO,SUGGESTION_THREE FROM
      http.open('POST', url, true);

      http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');


      http.send(params);
    },

    use_hihat(state){
      state.STREAMER.STREAMLABS=false;
      state.STREAMER.STREAMELEMENTS=false;
      state.STREAMER.HIHAT=true;
    },
    update_snackbar(state,data){
      state.APP.SNACKBAR.SHOW=true;
      state.APP.SNACKBAR.MESSAGE=data;
    },
    set_settings_data(state,data){
      state.STREAMER.IS_ADMIN=(data.IS_ADMIN===1);
      state.STREAMER.FIRST_NAME=data.FIRST_NAME;
      state.STREAMER.LAST_NAME=data.LAST_NAME;
      state.STREAMER.HAS_NIGHTBOT=data.HAS_NIGHTBOT;
      state.STREAMER.SID=data.SID;
      state.STREAMER.USER_NAME=data.USER_NAME;
      state.STREAMER.PHONE_NUMBER=data.PHONE_NUMBER;
      state.STREAMER.BANKACCOUNT=data.BANKACCOUNT;
      state.STREAMER.PAYMENT_TYPE=data.PAYMENT_TYPE;
      state.STREAMER.STREAMER_NAME=data.STREAMER_NAME;
      state.STREAMER.TWITCH_NAME=data.TWITCH_NAME;
      state.STREAMER.PERSONAL_NUMBER=data.PERSONAL_NUMBER;
      if(data.DISCORD_CHANNEL===null){
        state.STREAMER.DISCORD_CHANNEL="";
      }else{
        state.STREAMER.DISCORD_CHANNEL=data.DISCORD_CHANNEL;
      }









      if(data.REQUEST_TOKEN===true){
        state.STREAMER.STREAMELEMENTS=true;
      }
      else if(data.ACCESS_TOKEN===true){
        state.STREAMER.STREAMLABS=true;
      }
      else if(data.REQUEST_TOKEN==='HIHAT'){
        state.STREAMER.HIHAT=true;
      }
      else{
        state.STREAMER.STREAMELEMENTS=false;
        state.STREAMER.STREAMLABS=false;
      }
      if(data.EMAIL.includes("@nada.nada")){
        state.STREAMER.FAKE_EMAIL=data.EMAIL;
        state.STREAMER.EMAIL="";
      }
      else{
        state.STREAMER.EMAIL=data.EMAIL;
      }
      if(data.PHONE_NUMBER===null || data.PHONE_NUMBER==="null"){
        state.STREAMER.PHONE_NUMBER="";
      }
      if(data.PERSONAL_NUMBER===null || data.PERSONAL_NUMBER==="null"){
        state.STREAMER.PERSONAL_NUMBER="";
      }
      if(data.BANKACCOUNT===null || data.BANKACCOUNT==="null"){
        state.STREAMER.BANKACCOUNT="";
      }
      else{
        state.STREAMER.BANKACCOUNT=data.BANKACCOUNT.toString()
      }
      if(data.PAYMENT_TYPE===null || data.PAYMENT_TYPE==="null"){
        state.STREAMER.PAYMENT_TYPE="SWISH";

      }
      setTimeout(function(){
        state.APP.SETUP_LOADED=true;
      },500);



    },
    set_style_data(state,data){
      state.STYLE=data;
      if(data.IMAGE==="png" || data.IMAGE==="jpeg" || data.IMAGE==="gif"){

        state.MEDIA.HEADER="/api/images/headers/"+data.SID+"."+data.IMAGE
      }
      else{
        state.MEDIA.HEADER=null;
      }
     


    },
    set_num_trades(state,data){
      state.APP.NEW_TRADES=data;
    },
    set_num_cards(state,data){
      let prev_num_cards=parseInt(cookie.get("num_hicards"));

      state.APP.NEW_CARDS=data - prev_num_cards;
    },

    set_hicards_data(state,data){
      state.HICARDS=data;
      if(data.ACTIVE===0){
        state.HICARDS.ACTIVE=false;
      }
      else if(data.ACTIVE===1){
        state.HICARDS.ACTIVE=true;
      }
      setTimeout(function(){
        state.APP.HICARDS_LOADED=true;
      },500);
    },
    set_collection_cards(state,data){
      state.APP.INVENTORY.COLLECTION_CARDS=data;
    },
    set_action_cards(state,data){
      state.APP.INVENTORY.ACTION_CARDS=data;
    },


    update_user_image(state,data){
      state.MEDIA.USER_IMAGE=data;
    },
    update_payment_type(state,data){
      state.STREAMER.PAYMENT_TYPE=data;
    },
    header(state,data){
      state.MEDIA.HEADER=data;
    },
    USER_IMAGE(state,data){
      state.MEDIA.USER_IMAGE=data;
    },

    set_start_color(state,data){
      state.STYLE.START_COLOR=data;
    },
    set_end_color(state,data){
      state.STYLE.END_COLOR=data;
    },
    logout(state){
      state.STREAMER={
            FIRST_NAME:"EEEAAAAAA",
            LAST_NAME:"",
            STREAMELEMENTS:false,
            STREAMLABS:false,
            STREAMER_NAME:"",
            PHONE_NUMBER:"",
            BANK_ACCOUNT:"",
            PAYMENT_TYPE:"",
            PERSONAL_NUMBER:"",
            HAS_NIGHTBOT:false,
            SID:0,
            USER_NAME:""
      };
      state.MEDIA={
        USER_IMAGE:"/api/images/users/default.png"
      }
    }
  }
})
